import { FC } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { AdditionalServicesLease } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

// Index route of /additional-services. On desktop the list lives in the Leases
// layout; on mobile it renders here.
const AdditionalServicesLeaseList: FC = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return <UserProtectedRoute>{!isDesktop && <AdditionalServicesLease />}</UserProtectedRoute>
}

export default AdditionalServicesLeaseList
